import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade, EffectCards } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
	const classTarget = '.slider-cards';
	document.querySelectorAll(classTarget).forEach((el) => {
		let autoplayDelay = el.dataset?.slider_autoplay_delay;

		const swiperCards = new Swiper(classTarget, {
			modules: [Pagination, Autoplay, EffectFade, EffectCards],
			loop: true,
			// effect: 'fade',
			// fadeEffect: {
			// 	crossFade: true,
			// },
			// effect: 'flip',
			// flipEffect: {
			// 	slideShadows: false,
			// },
			effect: 'cards',
			cardsEffect: {
				perSlideOffset: 8,
				perSlideRotate: 4,
				rotate: true,
			},
			slidesPerView: 1,
			spaceBetween: 0,
			centeredSlides: true,
			preventClicks: false,
			allowTouchMove: true,
			autoplay: {
				delay: autoplayDelay || 2000,
				pauseOnMouseEnter: false,
				disableOnInteraction: false,
				waitForTransition: true,
			},
			speed: 1200,
		});
	});
});
